'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable import/no-extraneous-dependencies */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _UASubSection = require('./UASubSection');

var _UASubSection2 = _interopRequireDefault(_UASubSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var renderSubsections = function renderSubsections(sectionIndex, subsections, currentSubSectionIndex, setSubSection, scrollDirection) {
  return subsections.map(function (subsection, index) {
    return _react2.default.createElement(_UASubSection2.default, _extends({
      currentSubSectionIndex: currentSubSectionIndex,
      index: index,
      sectionIndex: sectionIndex,
      key: sectionIndex + '-' + index,
      scrollDirection: scrollDirection,
      setSubSection: setSubSection
    }, subsection));
  });
};

var UASection = function (_React$Component) {
  _inherits(UASection, _React$Component);

  function UASection() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UASection);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UASection.__proto__ || Object.getPrototypeOf(UASection)).call.apply(_ref, [this].concat(args))), _this), _this.handleScroll = function () {
      var _this$props = _this.props,
          currentSectionIndex = _this$props.currentSectionIndex,
          index = _this$props.index,
          setSection = _this$props.setSection,
          scrollDirection = _this$props.scrollDirection;

      if (_this.sectionRef) {
        var sectionTop = _this.sectionRef.getBoundingClientRect().top;
        var headerOffset = 62;
        var bannerOffset = 112;
        var topOffset = headerOffset + bannerOffset;
        if (scrollDirection === 'down' && sectionTop < headerOffset && currentSectionIndex < index) {
          setSection(index);
        } else if (scrollDirection === 'up' && currentSectionIndex === index + 1 && sectionTop > topOffset - _this.sectionRef.scrollHeight) {
          setSection(index);
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UASection, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          ppHeadline = _props.ppHeadline,
          anchorLink = _props.anchorLink,
          headline = _props.headline,
          subsections = _props.subsections,
          currentSectionIndex = _props.currentSectionIndex,
          index = _props.index,
          currentSubSectionIndex = _props.currentSubSectionIndex,
          setSubSection = _props.setSubSection,
          scrollDirection = _props.scrollDirection;

      var id = anchorLink && anchorLink.text ? anchorLink.text : 'UASection-' + index;
      // it is better to write the secion accepts children, and put the content logic in UserAgreement.jsx
      return _react2.default.createElement(
        'section',
        {
          id: id,
          className: 'ua-section',
          ref: function ref(el) {
            _this2.sectionRef = el;
          }
        },
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('row-fluid', 'row', 'sub-hero-banner-' + (index + 1), 'section' + (index + 1), {
              sticky: index === currentSectionIndex
            })
          },
          _react2.default.createElement(
            'div',
            { className: 'containerCentered container' },
            _react2.default.createElement(
              'div',
              { className: 'span12 col-sm-12 center-block center-text text-left' },
              _react2.default.createElement(
                'div',
                { className: 'editorial-cell' },
                ppHeadline && ppHeadline.text && _react2.default.createElement(
                  'h1',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    htmlToReactParser.parse(ppHeadline.text)
                  )
                ),
                headline && headline.text && _react2.default.createElement(
                  'h2',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    htmlToReactParser.parse(headline.text)
                  )
                )
              )
            )
          )
        ),
        renderSubsections(index, subsections, currentSubSectionIndex, setSubSection, scrollDirection)
      );
    }
  }]);

  return UASection;
}(_react2.default.Component);

exports.default = UASection;


UASection.propTypes = {
  ppHeadline: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  anchorLink: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  headline: _propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired
  }),
  subsections: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  currentSectionIndex: _propTypes2.default.number.isRequired,
  currentSubSectionIndex: _propTypes2.default.number.isRequired,
  index: _propTypes2.default.number.isRequired,
  scrollDirection: _propTypes2.default.string.isRequired,
  setSection: _propTypes2.default.func.isRequired,
  setSubSection: _propTypes2.default.func.isRequired
};

UASection.defaultProps = {
  ppHeadline: {
    text: ''
  },
  anchorLink: {
    text: ''
  },
  headline: {
    text: ''
  },
  subsections: []
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/user-agreement/jsx/UASection.js
// module id = 1155
// module chunks = 4